
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Cart.css";

export default function Cart({
  cart = [],
  setPage = () => {},
  decreaseQty = () => {},
  increaseQty = () => {},
  totalPrice = 0,
  language = "en",
  translations = {},
}) {


const navigate = useNavigate();
  const [discount] = useState(0);


  const text = {
    en: {
      title: "Shopping Cart",
      empty: "Your cart is empty 🛒",
      continue: "Continue Shopping",
      orderSummary: "Order Summary",
      totalItems: "Total Items",
      subtotal: "Subtotal",
      finalTotal: "Final Total",
      checkout: "Proceed To Checkout",
    },

    ur: {
      title: "شاپنگ کارٹ",
      empty: "آپ کی کارٹ خالی ہے 🛒",
      continue: "خریداری جاری رکھیں",
      orderSummary: "آرڈر خلاصہ",
      totalItems: "کل آئٹمز",
      subtotal: "ذیلی کل",
      finalTotal: "حتمی کل",
      checkout: "چیک آؤٹ پر جائیں",
    }
  };


  const t = text[language] || text.en;



  const getImage = (item)=>{

    let img =
      item.image_url ||
      item.image ||
      item.img;


    if(!img){
      return "/no-image.png";
    }


    if(img.startsWith("http")){
      return img;
    }


    return `https://onlinepk.me/admin/upload/item/${img}`;
  }



  const getProductName=(item)=>{

    if(language !== "ur"){
      return item.name;
    }


    return (
      translations?.ur?.products?.[item.id]?.name ||
      item.name ||
      "Product"
    );
  }



  const convertToUrduNumber=(value)=>{

    let number = Number(value) || 0;


    if(language !== "ur"){
      return number.toLocaleString();
    }


    let digits={
      0:"۰",
      1:"۱",
      2:"۲",
      3:"۳",
      4:"۴",
      5:"۵",
      6:"۶",
      7:"۷",
      8:"۸",
      9:"۹"
    };


    return number
    .toLocaleString()
    .split("")
    .map(n=>digits[n] || n)
    .join("");

  }



  const getPrice=(item)=>{

    return Number(
      item.price ??
      item.sale_price ??
      item.mrp ??
      0
    );

  }



  const subtotal = Number(totalPrice) || 0;

  const finalTotal =
  subtotal - (subtotal * discount)/100;



  // Empty Cart

  if(cart.length === 0){

    return (

      <div className="empty-cart">

        <h2>
          {t.empty}
        </h2>


        <button
        className="continue-btn"
        onClick={()=>setPage("home")}
        >

          {t.continue}

        </button>


      </div>

    );

  }





return (

<div className="cart-container">


<div className="cart-left">


<h1>
{t.title}
</h1>



{
cart.map((item)=>{


const price=getPrice(item);

const qty=Number(item.qty || 1);



return (

<div 
className="cart-item"
key={item.id}
>


<img

src={getImage(item)}

alt={item.name}

className="cart-image"

onError={(e)=>{

e.target.src="/no-image.png";

}}

/>



<div className="product-info">


<h3>
{getProductName(item)}
</h3>



<p>
Rs {convertToUrduNumber(price)}
</p>



<div className="qty-box">


<button
onClick={()=>decreaseQty(item.id)}
>
-
</button>



<span>
{convertToUrduNumber(qty)}
</span>



<button
onClick={()=>increaseQty(item.id)}
>
+
</button>


</div>


</div>




<h3 className="item-total">

Rs {convertToUrduNumber(price*qty)}

</h3>



</div>


)


})

}



</div>





<div className="cart-right">


<div className="summary-card">


<h2>
{t.orderSummary}
</h2>




<div className="summary-row">

<span>
{t.totalItems}
</span>


<span>
{convertToUrduNumber(cart.length)}
</span>

</div>





<div className="summary-row">

<span>
{t.subtotal}
</span>


<span>
Rs {convertToUrduNumber(subtotal)}
</span>


</div>




{
discount>0 &&

<div className="summary-row">

<span>
{t.finalTotal}
</span>


<span>
Rs {convertToUrduNumber(finalTotal)}
</span>


</div>

}




<button
className="checkout-btn"
onClick={() => navigate("/checkout")}
>
{t.checkout}
</button>



</div>


</div>



</div>

)

}